import * as React from "react";
import type { SVGProps } from "react";
const SvgInvoiceDocs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    viewBox="0 0 16 17" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.167 11.417H11M10.167 8.5H11M10.167 5.583H11M4.333 11.417h3.333M4.333 8.5h3.333M4.333 5.583h3.333"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.333 14.688V2.313a.83.83 0 0 0-.415-.721l-.825-.48a.83.83 0 0 0-.832-.002l-1.266.723-1.24-.72a.83.83 0 0 0-.834-.001l-1.254.721-1.255-.721a.83.83 0 0 0-.834.001l-1.24.72-1.266-.723a.83.83 0 0 0-.832.003l-.825.479a.83.83 0 0 0-.415.72v12.376c0 .297.158.571.415.72l.825.48c.257.149.574.15.832.002l1.266-.723 1.24.72c.258.15.576.15.834.001l1.255-.721 1.254.721a.83.83 0 0 0 .834-.001l1.24-.72 1.266.723a.83.83 0 0 0 .832-.003l.825-.479a.83.83 0 0 0 .415-.72"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInvoiceDocs;
